import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import { downloadPdf, errMsg } from './salaryApi';

const yearStart = () => `${new Date().getFullYear()}-01-01`;
const today = () => new Date().toISOString().slice(0, 10);

export const PaymentStatementCard = () => {
  const [from, setFrom] = useState(yearStart());
  const [to, setTo] = useState(today());
  const get = async () => {
    try { await downloadPdf(`/me/payment-statement?date_from=${from}&date_to=${to}`, `statement-${from}-${to}.pdf`); }
    catch (e) { toast.error(errMsg(e, 'Could not create statement')); }
  };
  return (
    <Card data-testid="payment-statement-card">
      <CardContent className="p-4 flex flex-col sm:flex-row sm:items-end gap-3">
        <div className="flex-1">
          <div className="font-semibold text-sm">Salary &amp; payment statement</div>
          <p className="text-xs text-muted-foreground">Installments, advances, deductions, totals paid and confirmed, remaining balances.</p>
        </div>
        <div><Label className="text-xs">From</Label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="statement-from" /></div>
        <div><Label className="text-xs">To</Label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} data-testid="statement-to" /></div>
        <Button variant="outline" onClick={get} data-testid="statement-download-btn"><Download size={14} className="mr-1" />PDF</Button>
      </CardContent>
    </Card>
  );
};
